import React from "react";
import { Link } from "gatsby";
import { Icons } from "./icons";
import { kebabCase } from "lodash";

export const BlogTitle = ({ children }) => {
  return (
    <h1
      id="introduction"
      className="text-3xl font-bold text-gray-600  tracking-tight"
    >
      {children}
    </h1>
  );
};

export const CardBox = ({ title, description, value }) => {
  return (
    <div className="bg-indigo-100 p-2 inline-block px-3 rounded  ">
      {/* <div className="font-semibold text-sm capitalize text-normal">
        {title}
      </div> */}
      <div className="text-3xl ">{value}</div>
      <span className="text-xs  inline-block mt-1">{description}</span>
    </div>
  );
};

export const ObservationBox = ({ title, children }) => {
  return (
    <div className="  p-2  ">
      <div className="text-lg mb-2"> {title}</div>
      <div>{children}</div>
    </div>
  );
};
export const SubTitle = ({ children }) => {
  return (
    <h1
      // id="introduction"
      className="mt-6 text-xl font-semibold text-gray-600  tracking-tight"
    >
      {children}
    </h1>
  );
};

export const Highlight = ({ children }) => {
  return (
    <span
      // id="introduction"
      className="border-b-2 border-indigo-500 texpt-lg font-semibold text-gray-600  tracking-tight"
    >
      {children}
    </span>
  );
};

export const SubSubTitle = ({ children }) => {
  return (
    <h1
      // id="introduction"
      className="mt- text-lg font-semibold text-gray-600  tracking-tight"
    >
      {children}
    </h1>
  );
};

export const BlogTitleInfo = ({ timeToRead, date, datetime }) => {
  return (
    <div className="mb-2 text-sm text-tertiary tracking-normal">
      <span>
        <time dateTime={datetime}>{date}</time>
      </span>
      <span> • </span>
      <span>{timeToRead} minute read</span>
    </div>
  );
};

export const Tags = ({ tags }) => {
  const tagsList = tags.map((tag, i) => {
    return (
      <span className="text-sm " key={"tagitem" + i}>
        {" "}
        <span className="hover:text-accent hover:underline">
          {" "}
          <Link to={`/blogtags/${kebabCase(tag)}/`}>{tag}</Link>
        </span>
        {tags.length !== i + 1 ? "," : ""}{" "}
      </span>
    );
  });
  return (
    <>
      {" "}
      <Icons icon={"tags"} /> {tagsList}
    </>
  );
};

export const PreviousNext = ({ previous, next }) => {
  return (
    <div className="flex mt-10">
      <div className="flex-1  no-und">
        {next && (
          <Link className="no-und" to={next.fields.slug} rel="next">
            <span className="border p-2 mr-2 "> ← Previous </span>
          </Link>
        )}
      </div>
      <div className="flex-1 text-right no-und">
        {previous && (
          <Link className="no-und" to={previous.fields.slug} rel="prev">
            <span className="border p-2 mr-2 no-und"> Next → </span>
          </Link>
        )}
      </div>
    </div>
  );
};

export const BoxSection = ({ title, children }) => {
  return (
    <div className="mt-10 border relative rounded p-2 pt-6">
      <div className="text-xl font-semibold rounded bg-white p-2 inline-block absolute px-3 -mt-12">
        {title}
      </div>
      {children}
    </div>
  );
};

export const ExtLink = ({ children, link, title, newTab }) => {
  if (newTab) {
    return (
      <a
        titlee={title}
        href={link}
        className="text-accent hover:text-accent hover:underline"
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
      </a>
    );
  } else {
    return (
      <a
        href={link}
        className="font-medium text-accent hover:text-accent hover:underline"
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
      </a>
    );
  }
};

export const DisplayTags = (tags) => {
  const tagsView = tags.map((tag, i) => {
    return (
      <span
        key={"rtag" + i}
        className="mr-1 inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-indigo-100 text-indigo-800"
      >
        <svg
          className="mr-1.5 h-2 w-2 text-indigo-400"
          fill="currentColor"
          viewBox="0 0 8 8"
        >
          <circle cx="4" cy="4" r="3" />
        </svg>
        {tag}
      </span>
    );
  });
  return tagsView;
};
